import { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import ReactTooltip from "react-tooltip";
import FrontendPage from "./Frontend";
import ToolPage from "./Tool";

import "react-toastify/dist/ReactToastify.css";

function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
}

function LayoutRouter() {
  return (
    <BrowserRouter>
      <ScrollToTop />
      <ToastContainer />
      <ReactTooltip globalEventOff="click" delayShow={400} />
      <Routes>
        <Route path="/tool/*" element={<ToolPage />} />
        <Route path="/*" element={<FrontendPage />} />
      </Routes>
    </BrowserRouter>
  );
}

export default LayoutRouter;
